<template>
  <!-- Pinned below the 56px (h-14) header and out of normal flow, so the
       workspace fills exactly the viewport beneath the header and can never grow
       the page body. Each column then owns its own independent vertical scroll. -->
  <!-- ⚠ `bg-background` on the fixed wrapper AND the scroller below is load
       bearing, not decoration. Both boxes get their own compositing layer
       (`position: fixed`, `overflow-y-auto`), and a layer whose background is
       not provably opaque loses subpixel antialiasing for its text and falls
       back to greyscale — which renders dark-on-light text visibly heavier.
       Symptoms this caused: « Retour » (the ONLY text sitting on the bare
       canvas — everything else is inside an opaque Card) appeared to go BOLD
       after a scroll or a text selection and snapped back on the next repaint,
       in LIGHT MODE ONLY, because light-on-dark hides the difference. The
       sidebar never did it: `<aside>` already carries `bg-card`. -->
  <div class="fixed inset-x-0 top-14 bottom-0 flex overflow-hidden bg-background">
    <!-- Workspace Sidebar — scrolls on its own; never moves with the main content -->
    <!-- The rail is CHROME on the card's plane in BOTH themes: the page is
         white, the rail is white, and the border between them is the only
         thing that says where one ends — the same rule that separates every
         card from its ground. A solid opaque token: the antialiasing note
         above needs provable opacity. -->
    <aside class="flex w-60 flex-col border-r bg-card shrink-0 overflow-y-auto">
      <SidebarNav class="flex-1 mt-4" />
    </aside>

    <!-- Workspace Main Content — the only thing that scrolls when the page is
         long. It adds NO padding of its own: the page owns its gutter
         (PageContainer px-6), and that gutter is what the header's own column
         lines up with. -->
    <main class="flex-1 overflow-y-auto relative bg-ground">
      <!-- ⚠ KEYED BY ROUTE NAME. Two routes may render ONE component told its
           page by static props (the pipeline's Ventes and Paiements), and
           vue-router REUSES the instance across them: the props change, but
           everything the page captured at setup — its legs, its reasons —
           stays the old page's. A key per route name remounts on that move
           and nowhere else (an id change on one route keeps its instance, as
           before). -->
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="String(route.name ?? route.path)" />
      </router-view>
    </main>
  </div>
</template>

<script setup lang="ts">
import SidebarNav from '@/components/layout/SidebarNav.vue'
</script>
